import React from 'react';
import PropTypes from 'prop-types';

import { Search } from '@material-ui/icons';
import {
  Autocomplete,
  InputAdornment,
  TextField,
  Paper,
  styled,
} from '@nextiva/next-ui-components';

import { GroupItems, GroupNamesHandling, LocationOption } from 'components';
import {
  filterLocations,
  parseSelectedLocation,
  parseLocationForDropdown,
} from 'parsers';

import './Location.scss';

export const blockName = 'location';

const LocationPaper = styled(Paper)(() => ({
  position: 'absolute',
  top: '100%',
  right: 0,
  minWidth: '38rem',
}));

const Location = ({ activeLocation, locationChange, locations }) => {
  const avaliableLocations = locations?.map(location =>
    parseLocationForDropdown(location)
  );

  /**
   * Validates if the option is the active one
   *
   * @param {{locationId: string; label: string; serviceLocationName: string;}} option
   * @returns {boolean} flag to indicate if the option is the active one
   */
  const isSelectedOption = option =>
    Object.entries(option).toString() ===
    Object.entries(activeLocation).toString();

  return (
    <div data-testid={blockName} className={blockName}>
      <div className={`${blockName}__dropdown-container`}>
        <Autocomplete
          id="locations-autoComplete"
          options={avaliableLocations}
          className={`${blockName}__autocomplete`}
          value={activeLocation}
          onChange={locationChange}
          groupBy={option => option.groupByBillSiteAndSiteName}
          renderGroup={params => (
            <li key={params.key}>
              <GroupNamesHandling props={params} />
              <GroupItems>{params.children}</GroupItems>
            </li>
          )}
          renderOption={(props, option) => (
            <LocationOption
              key={`${option.locationId}-${option.serviceLocationName}`}
              autoCompleteProps={props}
              option={option}
              isSelected={isSelectedOption(option)}
            />
          )}
          renderInput={params => (
            <TextField
              {...params}
              placeholder="Select a location"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              sx={{
                input: { textAlign: 'right' },
              }}
            />
          )}
          disableClearable
          getOptionLabel={parseSelectedLocation}
          filterOptions={filterLocations}
          PaperComponent={LocationPaper}
        />
      </div>
    </div>
  );
};

Location.defaultProps = {
  locations: [],
  activeLocation: {},
};

Location.propTypes = {
  locationChange: PropTypes.func.isRequired,
  locations: PropTypes.array.isRequired,
  activeLocation: PropTypes.object.isRequired,
};
export default Location;
